import { DocumentType } from '../../core-models';
import {
    buildEnumNameMap,
    getEnumValueByName,
    isEnumName,
} from './enum-name-format';

const DOCUMENT_TYPE_SOURCE_LABELS = {
    Other: 'Other',
    AsbestosManagementPlan: 'Asbestos Management Plan',
    AsbestosRegister: 'Asbestos Register',
    AsbestosSurveyReport: 'Asbestos Survey Report',
    EmergencyResponsePackFireBrigadeCorrespondence:
        'Fire Brigade Correspondence',
    EmergencyResponsePackFireBrigadeInformationPack:
        'Fire Brigade Information Pack',
    EmergencyResponsePackFireFightingFacilitiesLocationPlan:
        'Fire Fighting Facilities Location Plan',
    EmergencyResponsePackFireIndicatorPanelMap: 'Fire Indicator Panel Map',
    EmergencyResponsePackFireLogBook: 'Fire Log Book',
    EvacuationEvacuationStrategy: 'Evacuation Strategy',
    EvacuationFireDrillRecords: 'Fire Drill Records',
    EvacuationEvacuationPlans: 'Evacuation Plans',
    EvacuationWardenTrainingRecords: 'Emergency Warden Training Records',
    FireSafetyComplianceAnnualFireSafetyStatement:
        'Annual Fire Safety Statement',
    FireSafetyComplianceCladdingAuditReport: 'Cladding Audit Report',
    FireSafetyComplianceESMRegister: 'ESM Register',
    FireSafetyComplianceFireEngineeringReport: 'Fire Engineering Report',
    FireSafetyComplianceFireSafetySchedule: 'Fire Safety Schedule',
    FireSafetyComplianceSafetyCaseReport: 'Safety Case Report',
    FireStrategyCauseEffectMatrix: 'Cause & Effect Matrix',
    FireStrategyConstructionFireSafetyPlan: 'Construction Fire Safety Plan',
    FireStrategyEgressAssessment: 'Egress Assessment',
    FireStrategyFRLSchedule: 'FRL Schedule',
    HealthSafetyFilesWHSManagementPlan: 'WHS Management Plan',
    IncidentRiskReportingIncidentRegister: 'Incident Register',
    IncidentRiskReportingIncidentReport: 'Incident Report',
    PestControlPestControlReport: 'Pest Control Report',
    RiskAssessmentsCombustibleCladding: 'Combustible Cladding',
    RiskAssessmentsConfinedSpaces: 'Confined Spaces',
    RiskAssessmentsFireSafety: 'Fire Safety',
    RiskAssessmentsFlood: 'Flood',
    RiskAssessmentsGeneralWHS: 'General WHS',
    RiskAssessmentsHazardousSubstances: 'Hazardous Substances',
    RiskAssessmentsLegionella: 'Legionella',
    RiskAssessmentsNoise: 'Noise',
    RiskAssessmentsPlantEquipment: 'Plant Equipment',
    RiskAssessmentsRoofAccessWorkingAtHeights: 'Roof Access Working At Heights',
    RiskAssessmentsSafeDesign: 'Safe Design',
    RiskAssessmentsSafeWorkMethodStatement: 'SafeWork Method Statement',
    SpecificationsHealthSafetyAndComplianceCladding: 'Cladding',
    SpecificationsHealthSafetyAndComplianceFireDetectionAlarmSystems:
        'Fire Detection Alarm Systems',
    SpecificationsHealthSafetyAndComplianceFireDoors: 'Fire Doors',
    SpecificationsHealthSafetyAndComplianceFireExtinguishers:
        'Fire Extinguishers',
    SpecificationsHealthSafetyAndComplianceFireHydrantHoseReelSystems:
        'Fire Hydrant Hose Reel Systems',
    SpecificationsHealthSafetyAndComplianceInsulationFireCavityBarriers:
        'Insulation Fire Cavity Barriers',
    TrainingCompetenceHealthSafetyAndComplianceFirstAidTrainingRecords:
        'First Aid Training Records',
    TrainingCompetenceHealthSafetyAndComplianceSiteInductionRegister:
        'Site Induction Register',
    BuildingApprovalsBuildingPermitApplication: 'Building Permit Application',
    BuildingApprovalsBuildingSurveyorInspectionReport:
        'Building Surveyor Inspection Report',
    BuildingApprovalsCertificateOfFinalInspection:
        'Certificate Of Final Inspection',
    BuildingApprovalsOccupancyPermit: 'Occupancy Permit',
    BuildingApprovalsWorkSafeNotification: 'WorkSafe Notification',
    ContractsConstructionAndDevelopmentBankGuaranteeSecurity:
        'Bank Guarantee Security',
    ContractsConstructionAndDevelopmentBuildingContract: 'Building Contract',
    ContractsConstructionAndDevelopmentContractWorksInsurance:
        'Contract Works Insurance',
    ContractsConstructionAndDevelopmentContractorPrequalification:
        'Contractor Prequalification',
    ContractsConstructionAndDevelopmentExtensionOfTime: 'Extension Of Time',
    ContractsConstructionAndDevelopmentNotices: 'Notices',
    ContractsConstructionAndDevelopmentPrincipalsRequirements:
        'Principals Requirements',
    ContractsConstructionAndDevelopmentVariations: 'Variations',
    InspectionsReportsSurveysConstructionAndDevelopmentAirPermeabilityTestReport:
        'Air Permeability Test Report',
    InspectionsReportsSurveysConstructionAndDevelopmentDialBeforeYouDig:
        'Dial Before You Dig',
    InspectionsReportsSurveysConstructionAndDevelopmentFireBarrierPenetrationRecord:
        'Fire Barrier Penetration Record',
    InspectionsReportsSurveysConstructionAndDevelopmentFireCompartmentationSurvey:
        'Fire Compartmentation Survey',
    InspectionsReportsSurveysConstructionAndDevelopmentMeasurementAreaSurvey:
        'Measurement Area Survey',
    InspectionsReportsSurveysConstructionAndDevelopmentPhotoDocumentation:
        'Photo Documentation',
    InspectionsReportsSurveysConstructionAndDevelopmentSiteInspectionReport:
        'Site Inspection Report',
    InspectionsReportsSurveysConstructionAndDevelopmentStructuralInspectionReport:
        'Structural Inspection Report',
    PlanningCouncilCorrespondence: 'Planning - Council Correspondence',
    PlanningDevelopmentApplication: 'Development Application',
    PlanningDevelopmentConsent: 'Development Consent',
    PlanningHeritageImpactStatement: 'Heritage Impact Statement',
    PlanningPlanningAmendment: 'Planning Amendment',
    PlanningPlanningApproval: 'Planning Approval',
    PlanningPlanningRefusalNotice: 'Planning Refusal Notice',
    PlanningStatementOfEnvironmentalEffects:
        'Statement Of Environmental Effects',
    PlanningVoluntaryPlanningAgreement: 'Voluntary Planning Agreement',
    PlanningWorksInPublicDomainAgreement:
        'Planning - Works in Public Domain Agreement',
    PracticalCompletionDefectsAsBuiltInformationSchedule:
        'As-Built Information Schedule',
    PracticalCompletionDefectsCertificateOfMakingGood:
        'Certificate Of Making Good',
    PracticalCompletionDefectsDevelopersCompletionStatement:
        'Developers Completion Statement',
    PracticalCompletionDefectsOutstandingDefectsList:
        'Outstanding Defects List',
    PracticalCompletionDefectsPracticalCompletionCertificate:
        'Practical Completion Certificate',
    ProductMaterialInformationCladdingFacadeCertification:
        'Cladding Facade Certification',
    ProductMaterialInformationDoorsWindowsCertification:
        'Doors Windows Certification',
    ProductMaterialInformationFireStoppingCertification:
        'Fire Stopping Certification',
    ProductMaterialInformationFireStoppingInstallationRecord:
        'Fire Stopping Installation Record',
    ProductMaterialInformationFinishesSchedules: 'Finishes Schedules',
    ProductMaterialInformationPassiveFireProtectionCertification:
        'Passive Fire Protection Certification',
    ProductMaterialInformationProductInformation: 'Product Information',
    ProductMaterialInformationThirdPartyProductCertification:
        'Third-party Product Certification',
    ProjectInformationChangeControlLog: 'Change Control Log',
    ProjectInformationProjectFinancials: 'Project Financials',
    ProjectInformationProjectProgramme: 'Project Programme',
    ProjectInformationRemedialWorksScope: 'Remedial Works Scope',
    ProjectInformationSiteMeetingMinutes: 'Site Meeting Minutes',
    ProjectInformationTenderSubmissions: 'Tender Submissions',
    ProjectInformationTrafficManagementPlan: 'Traffic Management Plan',
    ProjectInformationWHSRiskRegister: 'WHS Risk Register',
    SpecificationsConstructionAndDevelopmentCoatings: 'Coatings',
    SpecificationsConstructionAndDevelopmentElectrical: 'Electrical',
    SpecificationsConstructionAndDevelopmentGeneralBuilding: 'General Building',
    SpecificationsConstructionAndDevelopmentInteriorDesignFitout:
        'Interior Design Fitout',
    SpecificationsConstructionAndDevelopmentNCCFireSafetyCompliance:
        'NCC Fire Safety Compliance',
    SpecificationsConstructionAndDevelopmentStructuralDesignCalculations:
        'Structural Design Calculations',
    SpecificationsConstructionAndDevelopmentWindLoading: 'Wind Loading',
    WarrantiesBuildingWarranty: 'Building Warranty',
    WarrantiesProductWarranties: 'Product Warranties',
    WarrantiesProfessionalIndemnity: 'Professional Indemnity',
    CommunicationSystemsStructuredCablingCertification:
        'Structured Cabling Certification',
    ContractsBuildingOperationsAndFacilitiesFacilitiesManagementContract:
        'Facilities Management Contract',
    ContractsBuildingOperationsAndFacilitiesRolesResponsibilitiesMatrix:
        'Roles & Responsibilities Matrix',
    ContractsBuildingOperationsAndFacilitiesServiceContractsSchedule:
        'Service Contracts Schedule',
    ElectricalSystemsCertification: 'Certification',
    ElectricalSystemsLoadCapacityMaximumDemand: 'Load Capacity Maximum Demand',
    ElectricalSystemsMeterReadings: 'Meter Readings',
    ElectricalSystemsProductInformation: 'Product Information',
    ElectricalSystemsSupplyAgreement: 'Supply Agreement',
    ElectricalSystemsSwitchboardDirectory: 'Switchboard Directory',
    ElectricalSystemsTestTagRegister: 'Test Tag Register',
    ElectricalSystemsGeneratorRecords: 'Generator Records',
    FinancialPPMCapExSchedule: 'PPM CapEx Schedule',
    FireDoorsDoorSchedule: 'Door Schedule',
    FireDoorsInspectionRecord: 'Inspection Record',
    FireDoorsSurveyGapAnalysis: 'Survey Gap Analysis',
    GasSystemsCertification: 'Certification',
    GasSystemsComplianceCertificate: 'Compliance Certificate',
    GasSystemsGasRoutingPlan: 'Gas Routing Plan',
    GasSystemsMaintenanceRecords: 'Maintenance Records',
    GasSystemsMeterReadings: 'Meter Readings',
    GasSystemsSupplyAgreement: 'Supply Agreement',
    GreaseTrapMaintenanceLog: 'Maintenance Log',
    EmbeddedNetworksCertification: 'Certification',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesAccessDDAAudit:
        'Access DDA Audit',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesBMUTestReport:
        'BMU Test Report',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesElectricalSurvey:
        'Electrical Survey',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesESMInspection:
        'ESM Inspection',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesFGasRefrigerantRegister:
        'F-Gas Refrigerant Register',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesFacadeCladdingInspection:
        'Facade Cladding Inspection',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesLuxLevelChecks:
        'Lux Level Checks',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesPeriodicInspectionReport:
        'Periodic Inspection Report',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesRoofSafetyInspection:
        'Roof Safety Inspection',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesTenancyInspectionReport:
        'Tenancy Inspection Report',
    LifeSafetySystemsCertification: 'Certification',
    LifeSafetySystemsEmergencyExitLightingTestRecords:
        'Emergency Exit Lighting Test Records',
    LifeSafetySystemsFireAlarmTestRecords: 'Fire Alarm Test Records',
    LifeSafetySystemsFireAlarmZonePlan: 'Fire Alarm Zone Plan',
    LifeSafetySystemsMaintenanceRecords: 'Maintenance Records',
    LifeSafetySystemsProductInformation: 'Product Information',
    LifeSafetySystemsSprinklerServiceReport: 'Sprinkler Service Report',
    LiftsElevatorsCertification: 'Certification',
    LiftsElevatorsMaintenanceRecords: 'Maintenance Records',
    OMManual: 'O&M Manual',
    OtherBuildingAssetsMaintenanceRecords: 'Maintenance Records',
    PermitsConfinedSpacesEntryPermit: 'Confined Spaces Entry Permit',
    PermitsElectricalWorkPermit: 'Electrical Work Permit',
    PermitsHotWorksPermit: 'Hot Works Permit',
    PermitsWorkingAtHeightsPermit: 'Working at Heights Permit',
    PoliciesProceduresStrategiesBuildingMaintenanceProcedures:
        'Building Maintenance Procedures',
    PoliciesProceduresStrategiesBuildingOperatingProcedures:
        'Building Operating Procedures',
    PoliciesProceduresStrategiesHardServicesMaintenancePlan:
        'Hard Services Maintenance Plan',
    PoliciesProceduresStrategiesSecurityPolicy: 'Security Policy',
    PoliciesProceduresStrategiesServicesStrategy: 'Services Strategy',
    PressureSystemsPressureInspectionReport: 'Pressure Inspection Report',
    SecuritySystemsAutomaticGateSafetyInspection:
        'Automatic Gate Safety Inspection',
    SecuritySystemsCertification: 'Certification',
    SecuritySystemsKeyAccessFobSchedule: 'Key Access Fob Schedule',
    SecuritySystemsProductInformation: 'Product Information',
    StaffingStaffEmploymentRecords: 'Staff Employment Records',
    SuppliersInformationSupplierContactInformation:
        'Supplier Contact Information',
    TrainingCompetenceBuildingOperationsAndFacilitiesBuildingSystemsTrainingRecords:
        'Building Systems Training Records',
    TrainingCompetenceBuildingOperationsAndFacilitiesManualHandlingTrainingRecords:
        'Manual Handling Training Records',
    UtilitiesMeterSchedule: 'Meter Schedule',
    UtilitiesUtilityBillsTariffs: 'Utility Bills / Tariffs',
    UtilitiesUtilitySupplyContracts: 'Utility Supply Contracts',
    UtilitiesWaterSupplyAgreements: 'Water Supply Agreements',
    VentilationSystemsCertification: 'Certification',
    VentilationSystemsHVACReport: 'HVAC Report',
    VentilationSystemsMaintenanceRecords: 'Maintenance Records',
    VentilationSystemsSystemDesign: 'System Design',
    WaterSystemsCertification: 'Certification',
    WaterSystemsLegionellaWaterQualityLogbook:
        'Legionella Water Quality Logbook',
    WaterSystemsMeterReadings: 'Meter Readings',
    WaterSystemsProductInformation: 'Product Information',
    WaterSystemsTankInspectionCleaningRecords:
        'Tank Inspection Cleaning Records',
    ArchitecturalFloorPlans: 'Floor Plans',
    ArchitecturalElevations: 'Elevations',
    ArchitecturalSections: 'Sections',
    ArchitecturalReflectedCeilingPlans: 'Reflected Ceiling Plans',
    ArchitecturalRoofPlans: 'Roof Plans',
    ArchitecturalInternalFinishesPlans: 'Internal Finishes Plans',
    ArchitecturalDemolitionPlans: 'Demolition Plans',
    ArchitecturalAsBuiltDrawings: 'As Built Drawings',
    CivilStructuralSitePlans: 'Site Plans',
    CivilStructuralStructuralDrawings: 'Structural Drawings',
    CivilStructuralFoundationPlans: 'Foundation Plans',
    CivilStructuralStormwaterDrainagePlans: 'Stormwater Drainage Plans',
    CivilStructuralEarthworksGradingPlans: 'Earthworks Grading Plans',
    CivilStructuralRetainingWallDrawings: 'Retaining Wall Drawings',
    CivilStructuralAsBuiltDrawings: 'As Built Drawings',
    MechanicalHVACLayoutPlans: 'HVAC Layout Plans',
    MechanicalMechanicalSchematicDrawings: 'Mechanical Schematic Drawings',
    MechanicalPlantRoomDrawings: 'Plant Room Drawings',
    MechanicalDuctworkDrawings: 'Ductwork Drawings',
    MechanicalAsBuiltDrawings: 'As Built Drawings',
    ElectricalElectricalLayoutPlans: 'Electrical Layout Plans',
    ElectricalSwitchboardDistributionDrawings:
        'Switchboard Distribution Drawings',
    ElectricalLightingPlans: 'Lighting Plans',
    ElectricalEmergencyLightingPlans: 'Emergency Lighting Plans',
    ElectricalAsBuiltDrawings: 'As Built Drawings',
    FireLifeSafetySprinklerLayoutPlans: 'Sprinkler Layout Plans',
    FireLifeSafetyFireHydrantHoseReelPlans: 'Fire Hydrant Hose Reel Plans',
    FireLifeSafetyFireDetectionAlarmLayout: 'Fire Detection Alarm Layout',
    FireLifeSafetySmokeControlDrawings: 'Smoke Control Drawings',
    FireLifeSafetyAsBuiltDrawings: 'As Built Drawings',
    HydraulicHydraulicLayoutPlans: 'Hydraulic Layout Plans',
    HydraulicHotColdWaterServices: 'Hot Cold Water Services',
    HydraulicDrainageSewerPlans: 'Drainage Sewer Plans',
    HydraulicGasServicesPlans: 'Gas Services Plans',
    HydraulicAsBuiltDrawings: 'As Built Drawings',
    LandscapeLandscapePlans: 'Landscape Plans',
    LandscapeIrrigationPlans: 'Irrigation Plans',
    LandscapeAsBuiltDrawings: 'As Built Drawings',
    FacadeCladdingFacadeDrawings: 'Facade Drawings',
    FacadeCladdingCladdingDetails: 'Cladding Details',
    FacadeCladdingWindowGlazingDrawings: 'Window Glazing Drawings',
    FacadeCladdingAsBuiltDrawings: 'As Built Drawings',
    ComplianceCertificatesNABERSRatingCertificate: 'NABERS Rating Certificate',
    ComplianceCertificatesNatHERSCertificate: 'NatHERS Certificate',
    ComplianceCertificatesNCCSectionJReport: 'NCC Section J Report',
    GroundGeotechnicalGeotechnicalInvestigationReport:
        'Geotechnical Investigation Report',
    GroundGeotechnicalRemediationMethodStatement:
        'Remediation Method Statement',
    GroundGeotechnicalRemediationValidationReport:
        'Remediation Validation Report',
    InspectionsReportsSurveysEnvironmentalAndSiteAcousticAssessment:
        'Acoustic Assessment',
    InspectionsReportsSurveysEnvironmentalAndSiteAirQualityAssessment:
        'Air Quality Assessment',
    InspectionsReportsSurveysEnvironmentalAndSiteArboristReport:
        'Arborist Report',
    InspectionsReportsSurveysEnvironmentalAndSiteBASIXCertificate:
        'BASIX Certificate',
    InspectionsReportsSurveysEnvironmentalAndSiteEnvironmentalSiteAssessment:
        'Environmental Site Assessment',
    InspectionsReportsSurveysEnvironmentalAndSiteFloraFaunaAssessment:
        'Flora Fauna Assessment',
    InspectionsReportsSurveysEnvironmentalAndSiteHeritageImpactStatement:
        'Heritage Impact Statement',
    InspectionsReportsSurveysEnvironmentalAndSiteNetZeroCarbonAssessment:
        'Net Zero Carbon Assessment',
    InspectionsReportsSurveysEnvironmentalAndSiteOvershadowingAnalysis:
        'Overshadowing Analysis',
    LicencesNoticesEPALicence: 'EPA Licence',
    LicencesNoticesStormwaterDischargeLicence: 'Stormwater Discharge Licence',
    WasteWasteManagementPlan: 'Waste Management Plan',
    WasteWasteManagementStrategy: 'Waste Management Strategy',
    WasteWasteTransferDocumentation: 'Waste Transfer Documentation',
    EasementsRightOfWayEasementsRightOfCarriageway:
        'Easements / Right of Carriageway',
    HeadLease: 'Head Lease',
    LicencesRoomingHouseRegistration: 'Rooming House Registration',
    MarketingInformationMemorandum: 'Information Memorandum',
    PartyWallPartyWallBoundaryDisputes: 'Party Wall Boundary Disputes',
    RentOutgoingsArrearsSchedule: 'Rent / Outgoings Arrears Schedule',
    RentOutgoingsBudget: 'Budget',
    RentOutgoingsExpenditureAccounts: 'Outgoings - Expenditure / Accounts',
    RentOutgoingsNotices: 'Rent / Outgoings Notices',
    RentOutgoingsOutgoingsSchedule: 'Outgoings Schedule',
    RentOutgoingsPaymentHistory: 'Rent / Outgoings Payment History',
    RentOutgoingsRentalAnalysis: 'Rental Analysis',
    RentOutgoingsSinkingFund: 'Sinking Fund',
    ResidentTenantEngagementTenantCommunication: 'Tenant Communication',
    ResidentTenantEngagementTenantCorrespondence: 'Tenant Correspondence',
    ResidentTenantEngagementTenantHandbook: 'Tenant Handbook',
    TenanciesUnitsAddressLotSchedule: 'Address Lot Schedule',
    TenanciesUnitsLeaseAgreements: 'Lease Agreements',
    TenanciesUnitsNetLettableAreaSchedule: 'Net Lettable Area Schedule',
    TenanciesUnitsScheduleOfCondition: 'Schedule Of Condition',
    TenanciesUnitsTenancySchedule: 'Tenancy Schedule',
    TitleCaveatsConsents: 'Caveats Consents',
    TitleCertificateOfTitle: 'Certificate Of Title',
    TitlePlanOfSubdivision: 'Plan Of Subdivision',
    TitleTitleSearch: 'Title Search',
    TitleTransferOfLand: 'Transfer Of Land',
    TransactionsContractOfSale: 'Contract Of Sale',
    TransactionsDueDiligence: 'Due Diligence',
    TransactionsLitigationDisputes: 'Litigation Disputes',
    InsuranceClaimsDisputesClaims: 'Claims',
    InsuranceClaimsDisputesDisputes: 'Disputes',
    InsurancePoliciesCertificatesBuilding: 'Building',
    InsurancePoliciesCertificatesContents: 'Contents',
    InsurancePoliciesCertificatesProfessionalIndemnity:
        'Professional Indemnity',
    InsurancePoliciesCertificatesPublicLiability: 'Public Liability',
    InsurancePoliciesCertificatesStrata: 'Strata',
    InsurancePoliciesCertificatesTerrorismCover: 'Terrorism Cover',
    InsurancePoliciesCertificatesWorkersCompensation: 'Workers Compensation',
    TaxABNEntityRegistration: 'Tax - ABN / Entity Registration',
    TaxBASGSTRegistration: 'BAS / GST Registration',
    TaxDepreciationSchedule: 'Depreciation Schedule',
    TaxCouncilRates: 'Council Rates',
    TaxLandTax: 'Land Tax',
    TaxStampDuty: 'Stamp Duty',
    ValuationsValuationReport: 'Valuation Report',
    AsbestosOther: 'Other',
    EmergencyResponsePackOther: 'Other',
    EvacuationOther: 'Other',
    FireSafetyComplianceOther: 'Other',
    FireStrategyOther: 'Other',
    HealthSafetyFilesOther: 'Other',
    IncidentRiskReportingOther: 'Other',
    PestControlOther: 'Other',
    RiskAssessmentsOther: 'Other',
    SpecificationsHealthSafetyAndComplianceOther: 'Other',
    TrainingCompetenceHealthSafetyAndComplianceOther: 'Other',
    BuildingApprovalsOther: 'Other',
    ContractsConstructionAndDevelopmentOther: 'Other',
    InspectionsReportsSurveysConstructionAndDevelopmentOther: 'Other',
    PlanningOther: 'Other',
    PracticalCompletionDefectsOther: 'Other',
    ProductMaterialInformationOther: 'Other',
    ProjectInformationOther: 'Other',
    SpecificationsConstructionAndDevelopmentOther: 'Other',
    WarrantiesOther: 'Other',
    CommunicationSystemsOther: 'Other',
    ContractsBuildingOperationsAndFacilitiesOther: 'Other',
    ElectricalSystemsOther: 'Other',
    FinancialOther: 'Other',
    FireDoorsOther: 'Other',
    GasSystemsOther: 'Other',
    GreaseTrapOther: 'Other',
    EmbeddedNetworksOther: 'Other',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesOther: 'Other',
    LifeSafetySystemsOther: 'Other',
    LiftsElevatorsOther: 'Other',
    OMManualOther: 'Other',
    OtherBuildingAssetsOther: 'Other',
    PermitsOther: 'Other',
    PoliciesProceduresStrategiesOther: 'Other',
    PressureSystemsOther: 'Other',
    SecuritySystemsOther: 'Other',
    StaffingOther: 'Other',
    SuppliersInformationOther: 'Other',
    TrainingCompetenceBuildingOperationsAndFacilitiesOther: 'Other',
    UtilitiesOther: 'Other',
    VentilationSystemsOther: 'Other',
    WaterSystemsOther: 'Other',
    ArchitecturalOther: 'Other',
    CivilStructuralOther: 'Other',
    MechanicalOther: 'Other',
    ElectricalOther: 'Other',
    FireLifeSafetyOther: 'Other',
    HydraulicOther: 'Other',
    LandscapeOther: 'Other',
    FacadeCladdingOther: 'Other',
    ComplianceCertificatesOther: 'Other',
    GroundGeotechnicalOther: 'Other',
    InspectionsReportsSurveysEnvironmentalAndSiteOther: 'Other',
    LicencesNoticesOther: 'Other',
    WasteOther: 'Other',
    EasementsRightOfWayOther: 'Other',
    HeadLeaseOther: 'Other',
    LicencesOther: 'Other',
    MarketingOther: 'Other',
    PartyWallOther: 'Other',
    RentOutgoingsOther: 'Other',
    ResidentTenantEngagementOther: 'Other',
    TenanciesUnitsOther: 'Other',
    TitleOther: 'Other',
    TransactionsOther: 'Other',
    InsuranceClaimsDisputesOther: 'Other',
    InsurancePoliciesCertificatesOther: 'Other',
    TaxOther: 'Other',
    ValuationsOther: 'Other',
    InspectionsReportsSurveysBuildingOperationsAndFacilitiesServiceReport:
        'Service Report',
} as const satisfies Readonly<Record<keyof typeof DocumentType, string>>;

export type DocumentTypeName =
    (typeof DOCUMENT_TYPE_SOURCE_LABELS)[keyof typeof DOCUMENT_TYPE_SOURCE_LABELS];

export const DocumentTypeName = buildEnumNameMap(
    DocumentType,
    DOCUMENT_TYPE_SOURCE_LABELS
);

export function getDocumentTypeName(
    documentType: DocumentType
): DocumentTypeName {
    return DocumentTypeName[documentType];
}

export function getDocumentType(
    documentTypeName: DocumentTypeName
): DocumentType {
    const documentType = getEnumValueByName(DocumentTypeName, documentTypeName);

    if (documentType !== null) {
        return documentType;
    }

    throw new TypeError(`No DocumentType found for name: ${documentTypeName}`);
}

export function isDocumentTypeName(
    documentTypeName: string
): documentTypeName is DocumentTypeName {
    return isEnumName(DocumentTypeName, documentTypeName);
}
